export function roundUpTo15Min(seconds) {
  if (!seconds) return 0
  return Math.ceil(seconds / 900) * 900
}

export function fmtDuration(seconds) {
  if (!seconds && seconds !== 0) return '—'
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  if (h > 0) return `${h}h ${m.toString().padStart(2, '0')}m`
  return `${m}m`
}

export function fmtHours(seconds) {
  if (!seconds) return '0h 0m'
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  return h > 0 ? `${h}h ${m}m` : `${m}m`
}

export function decimalHours(seconds) { return seconds / 3600 }

export function fmtMoney(n) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(n || 0)
}

export function fmtDate(iso) {
  const d = new Date(iso)
  const today = new Date()
  const yesterday = new Date(); yesterday.setDate(today.getDate() - 1)
  if (d.toDateString() === today.toDateString()) return 'Today'
  if (d.toDateString() === yesterday.toDateString()) return 'Yesterday'
  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })
}

export function fmtTime(iso) {
  return new Date(iso).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
}

export function fmtMonthKey(iso) { return iso ? iso.slice(0, 7) : '' }

export function fmtMonthLabel(yyyyMM) {
  if (!yyyyMM) return ''
  const [y, m] = yyyyMM.split('-')
  return new Date(Number(y), Number(m) - 1, 1).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
}

export function currentMonthKey() {
  const now = new Date()
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
}

export function computePausedMs(pauses = [], pausedSince = null) {
  let ms = pauses.reduce((sum, p) => {
    if (p.paused_at && p.resumed_at) return sum + (new Date(p.resumed_at) - new Date(p.paused_at))
    return sum
  }, 0)
  if (pausedSince) ms += Date.now() - new Date(pausedSince).getTime()
  return ms
}

export function groupByDate(entries) {
  const groups = {}
  entries.forEach(e => {
    const key = new Date(e.started_at).toDateString()
    if (!groups[key]) groups[key] = []
    groups[key].push(e)
  })
  return Object.entries(groups).sort((a, b) => new Date(b[0]) - new Date(a[0]))
}
